import { _ } from '../../vendor'
import InboomaBaseModel from './InboomaBaseModel'
import Prices from '../collections/Prices'

export default InboomaBaseModel.extend({

  urlRoot : '/pricetariffs',

  defaults : {
    "id" : "",
    "name" : "",
    "description" : "",
    "begin" : "",
    "end" : "",
    "client_id" : "",
    "duration" : "",
    "contingents" : [],
    "prices" : [],
    "created" : "",
    "modified" : "",
  },

  _rbac : {
      "admin" : {
          "read" : true,
          "write" : true,
          "edit" : true,
          "remove" : true
      },
      "user" : {
          "read" : true,
          "write" : false,
          "edit" : false,
          "remove" : false
      },
      "garage-staff" : {
        "read" : true,
        "write" : false,
        "edit" : false,
        "remove" : false
      },
      "manager" : {
          "read" : true,
          "write" : false,
          "edit" : false,
          "remove" : true
      },
      "booking-manager" : {
        "read" : true,
        "write" : false,
        "edit" : false,
        "remove" : true
    },
      "manager-location" : {
        "read" : true,
        "write" : false,
        "edit" : false,
        "remove" : true
    }
  },

  initialize () {

    if (this.get('id') !== ''
        && !_.isNull(this.get('prices'))
        && this.get('prices').length >= 1) {

      this.set('prices', new Prices(this.get('prices')));

    } else {

      this.set('prices', new Prices());
      this.get('prices').add({});

    }

      this.initializeFakeFields();
      this.on('duration', (that) => {
          that.initializeFakeFields();
      });
  },

    initializeFakeFields () {
        let _duration =  parseInt(this.get('duration'));
        if (_duration != 0 && (_duration != '' || _.isNaN(_duration))) {
            if (_duration >= 86400) {
                this.set('_rate', 86400);
                this.set('_amount',(_duration/86400));
            } else if (_duration >= 3600) {
                this.set('_rate', 3600);
                this.set('_amount',(_duration/3600));
            } else if (_duration >= 60) {
                this.set('_rate', 60);
                this.set('_amount',(_duration/60));
            }
        }
    },
  
})